module.exports = __webpack_public_path__ + "media/images/lp/ashinaga-aai/home/home-global-bg-2-sp-2cf6c711501cfee147ee0d15cc2cdf1b.png";